// For department AND default deadline settings:
// deadline can be value 0 - 30
// if deadline is -1 or 'undefined', there is not a deadline
export function dueDateAfterTerm(section, defaultDeadline) {
  const sectionDeadline =
    section.offering.days_after_term_finalization_deadline;
  if (sectionDeadline >= 0 && sectionDeadline !== null) {
    return section.offering.days_after_term_finalization_deadline;
  }
  if (defaultDeadline >= 0) {
    return defaultDeadline;
  }
  return null;
}

export function getTermEndDate(term, insightsTerms) {
  let termEndDate;
  if (term.end_at && term.canvas_id !== 1) {
    // Use the term's end date if available and the term is not the "Default Term"
    termEndDate = new Date(term.end_at);
  } else if (term.insights_term_id) {
    // Fallback to insights term (if it exists) end date if the term has an associated insights_term_id
    const insightsTerm = insightsTerms.find(
      (t) => t.id === term.insights_term_id
    );
    // Only if not the default insights term
    if (insightsTerm && insightsTerm.end_at !== "default") {
      termEndDate = new Date(insightsTerm.end_at);
    }
  }
  return termEndDate;
}

export function getDueDate(term, daysAfterTerm, insightsTerms) {
  // If no deadline, there is no due date
  if (daysAfterTerm === null) {
    return undefined;
  }
  const termEndDate = getTermEndDate(term, insightsTerms);
  // If there is no reasonable term with an end at date, there is no due date
  if (!termEndDate) {
    return undefined;
  }

  const dueDate = new Date(termEndDate);
  dueDate.setDate(dueDate.getDate() + daysAfterTerm);
  return dueDate;
}
